<template>
  <!-- eslint-disable vue/no-multiple-template-root -->
  <slot />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useHead } from 'nuxt/app'

export default defineComponent({
  name: 'PrintLayout',
  setup() {
    useHead({
      script: [
        () => ({
          src: 'https://unpkg.com/pagedjs/dist/paged.polyfill.js',
        }),
      ],
    })
  },
})
</script>
